
import Footer from "../Footer";

import './index.css'

const Disclaimer = () => (
    <div class="td-container tdc-content-wrap ">
        <div class="td-crumb-container">
            <div class="entry-crumbs"><span><a title="" class="entry-crumb" href="/">Home</a></span> <i class="td-icon-right td-bread-sep td-bred-no-url-last"></i> <span class="td-bred-no-url-last">Disclaimer for One Solutions</span></div>        </div>
        <div class="td-pb-row">
            <div class="td-pb-span8 td-main-content" role="main">
                <div class="td-ss-main-content">
                    <div class="td-page-header">
                        <h1 class="entry-title td-page-title">
                            <span>Disclaimer for One Solutions</span>
                        </h1>
                    </div>
                    <div class="td-page-content tagdiv-type">
                        <p>One Solutions Disclaimer</p>
                        
                        <p>If you require any more information or have any questions about our site’s disclaimer, please feel free to contact us by email at onesolutions06092024@gmail.com</p>
                        <p>Disclaimers for ONE SOLUTIONS</p>
                        <p>All the information on this website – https://onesolutions.onrender.com/ – is published in good faith and for general information purpose only.</p>
                        <p>ONE SOLUTIONS does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website (ONE SOLUTIONS), is strictly at your own risk.</p>
                        <p>ONE SOLUTIONS will not be liable for any losses and/or damages in connection with the use of our website. Our Disclaimer was generated with the help of the Disclaimer Generator and the Terms and Conditions Template.</p>
                        <p>From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone ‘bad’.</p>
                        <p>Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their “Terms of Service” before engaging in any business or uploading any information.</p>
                        <p>Consent
                            <br />
                            By using our website, you hereby consent to our disclaimer and agree to its terms.</p>
                        <p>Update
                            <br />

                            Should we update, amend or make any changes to this document, those changes will be prominently posted here.</p>
                    </div>
                </div>
            </div>
            
        </div>
        <Footer />
    </div>

)

export default Disclaimer